import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../../../components/ReUseAbleComponents/Shared";

function Forums(props) {
  return (
    <>
      {" "}
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-9">Forums</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>Forums</li>
                    </ul>
                  </div>
                  <div className="table-responsive">
                    <table className="dx-table dx-table-default">
                      <thead>
                        <tr>
                          <th scope="col">Forums</th>
                          <th scope="col">Topics</th>
                          <th scope="col">Posts</th>
                          <th scope="col">Last Post</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">
                            <Link
                              to="/topics"
                              className="dx-table-default-title"
                            >
                              Design with pleasure
                            </Link>
                            <p className="mb-0">
                              Sodales pharetra condimentum. Curabitur hendrerit
                              odio, ad libero tempus dis duis suspendisse
                              euismod.
                            </p>
                          </th>
                          <td>45</td>
                          <td>367</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Joseph Harper</Link>
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">
                            <Link
                              to="/topics"
                              className="dx-table-default-title"
                            >
                              Web Design Jobs & Developer Jobs
                            </Link>
                            <p className="mb-0">
                              Mattis nonummy massa aliquam ad pretium. Ipsum mi
                              litora penatibus.
                            </p>
                          </th>
                          <td>12</td>
                          <td>206</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Paul Shaw</Link>
                                <span className="dib">23 Feb 2018,</span>{" "}
                                <span className="dib">11:02 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">
                            <Link
                              to="/topics"
                              className="dx-table-default-title"
                            >
                              Group Testing
                            </Link>
                            <p className="mb-0">Testing.</p>
                          </th>
                          <td>05</td>
                          <td>98</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Gramziu</Link>
                                <span className="dib">22 Feb 2018,</span>{" "}
                                <span className="dib">10:24 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">
                            <Link
                              to="/topics"
                              className="dx-table-default-title"
                            >
                              Upcomming Features
                            </Link>
                            <p className="mb-0">
                              Vel dui sapien condimentum sodales pretium nostra
                              parturient. Pulvinar odio.
                            </p>
                          </th>
                          <td>91</td>
                          <td>614</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Mary Cain</Link>
                                <span className="dib">20 Feb 2018,</span>{" "}
                                <span className="dib">10:42 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">
                            <Link
                              to="/topics"
                              className="dx-table-default-title"
                            >
                              Web Designer Forum News
                            </Link>
                            <p className="mb-0">
                              Iaculis libero neque. Sociosqu pretium nisi
                              blandit consequat posuere leo.
                            </p>
                          </th>
                          <td>08</td>
                          <td>37</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Robert Holmes</Link>
                                <span className="dib">19 Feb 2018,</span>{" "}
                                <span className="dib">8:59 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Forums;
